import React from "react";
import { Alert, Link as MuiLink, Typography } from "@mui/material";

export const IMPLEMENTATION_FORM_URL =
  "https://havenconnect.formstack.com/forms/implementation_form";

type Props = {
  show: boolean;
}

export const ImplementationFormNote: React.FC<Props> = ({ show }) => {
  if (!show) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <Typography variant="body2" component="span">
        Next up: Fill out the{" "}
        <MuiLink
          href={IMPLEMENTATION_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          implementation form
        </MuiLink>
      </Typography>
    </Alert>
  );
};
